import { useEffect, useState } from 'react'

/** Value that settles `delay` ms after the input stops changing. */
export function useDebounce<T>(value: T, delay = 300): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return settled
}
